module.exports = __webpack_public_path__ + "static/media/res10.26f8b31c.PNG";